import { Log } from '@/parsing/Log';
import { LogEntryType } from '@/parsing/LogEntry';

import { TimelineMarker, TimelineRow, TimelineRowGroup } from '../../TimelineData';
import { obtainFreeRowForMarker } from '../obtainFreeRowForMarker';
import { TimelineGeneratorContext } from '../TimelineGeneratorContext';

export function generateAndroidRouterGroupFromLog(
  log: Log,
  ctx: TimelineGeneratorContext,
): TimelineRowGroup {
  const rows: TimelineRow[] = [];

  for (const entry of log.entries) {
    if (entry.entryType !== LogEntryType.Generic) {
      continue;
    }
    if (entry.extra.generic?.module !== 'RIB') {
      continue;
    }
    if (!entry.content.includes('didBecomeActive') && !entry.content.includes('willResignActive')) {
      continue;
    }

    const tooltipContent = entry.content;
    let textOnMarker = '';

    const didBecomeActive = tooltipContent.includes('didBecomeActive');
    if (didBecomeActive) {
      textOnMarker = `Active: ${entry.content.split(' ')[0]}`;
    } else {
      textOnMarker = `Inactive: ${entry.content.split(' ')[0]}`;
    }

    const marker: TimelineMarker = {
      markerId: ctx.nextMarkerId,
      logEntry: entry,
      startTimeMs: entry.date.getTime(),
      endTimeMs: undefined,
      fillColor: didBecomeActive ? '#99fcd6' : '#ccb19d',
      textOnMarker,
      textOnMarkerColor: didBecomeActive ? '#338a63' : '#874b63',
      tooltipContent,
    };
    ctx.nextMarkerId += 1;

    const row = obtainFreeRowForMarker(rows, marker);
    row.markers.push(marker);
  }

  return {
    name: 'Router',
    rows,
    expanded: true,
  };
}
